import $http from '../../axios-instance';
import Swal from 'sweetalert2';
import {defaultpayloadFormCategory} from "@/servicios/videos/state";

/**
 * Obtener categorias de videos.
 * @autor Paul Valencia
 */
export async function getvidVideoCategories({commit}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`vid_videos_categories`);
        commit('setVideoCategories',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Guardar video.
 * @param payload
 * @autor Paul Valencia
 */
export async function saveVideo({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`admin/vid_videos`, payload);
        commit('changeStateModalForm', false);
        commit('setPayloadForm', state.defaultPayloadForm);
        dispatch('getvidVideos', state.filter);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtener videos administrador.
 *
 * @autor Paul Valencia
 * @param payload
 */
export async function getvidVideos({commit},payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`admin/vid_videos`, {params: {...payload}});
        commit('setVideos',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Eliminar archivo de video.
 *
 * @param id
 * @autor Paul Valencia
 * @returns void
 */
export async function deleteVideoFile(context, id) {
    await $http.patch(`admin/vid_files/${id}/delete`).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}

/**
 * Guardar video.
 * @param payload:
 * @autor Paul Valencia
 */
export async function updateVideo({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`admin/vid_videos_update/`, payload);
        commit('changeStateModalForm', false);
        commit('setPayloadForm', state.defaultPayloadForm);
        dispatch('getvidVideos', state.filter);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Eliminar registro.
 *
 * @param payload: id
 * @autor Paul Valencia
 * @returns void
 */
export async function deleteVidVideo(context, id) {
    await $http.patch(`admin/vid_videos/${id}/delete`).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}

/**
 * Obtener videos de empresa
 *
 * @param payload: id
 * @autor Paul Valencia
 * @returns void
 */
export async function getvidVideosByCompany({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`vid_videos_by_company`, {params: {...payload}});
        commit('setVideosByCategory', {categoryId: payload.vid_video_category_id,videos: response.data.data });
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Obtiene el listado de categorias con videos asociados a la empresa.
 * @autor Paul Valencia
 */
export async function getvidVideoCategoriesCompany({commit}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`vid_videos_categories_company`);
        commit('setVideoCategories',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Guardar categoria.
 * @param payload
 * @autor Paul Valencia
 */
export async function saveCategory({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`admin/vid_categories`, payload);
        commit('changeStateModalFormCategory', false);
        commit('setPayloadFormCategory', defaultpayloadFormCategory());
        dispatch('getCategoriesWithSubcategories', state.filterCategories);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Obtiene el listado de categorias con subcategorias de videos.
 * @autor Paul Valencia
 */
export async function getCategoriesWithSubcategories({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get(`vid_categories_subcategories`,{params: {...payload}});
        commit('setVidCategoriesSubcategories',response.data.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Actualizar categoria.
 * @param payload:
 * @autor Paul Valencia
 */
export async function updateCategory({state,commit,dispatch}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`admin/vid_categories_update/`, payload);
        commit('changeStateModalFormCategory', false);
        commit('setPayloadFormCategory', defaultpayloadFormCategory());
        dispatch('getCategoriesWithSubcategories', state.filterCategories);
        this.$vue.$alertSuccess(response.data.message);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}


/**
 * Eliminar categoria.
 *
 * @param payload: id
 * @autor Paul Valencia
 * @returns void
 */
export async function deleteVidCategory(context, id) {
    await $http.patch(`admin/vid_categories/${id}/delete`).then(async (response) => {
        this.$vue.$alertSuccess(response.data.message);
    }).catch(async (error) => {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    });
}
